<template>
    <a-card>

    <div>
        <h3 style="text-align: center;margin:20px 0 40px">相关附件</h3>
        <a-form layout="vertical"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <!-- <div > -->
                <a-col :span="24">
                    <a-form-item label="ID主键" name="id">
                        <a-input v-model:value="form.id" placeholder="请输入ID主键" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目ID" name="projectId">
                        <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="分类ID" name="classification">
                        <a-input v-model:value="form.classification" placeholder="请输入分类ID" />
                    </a-form-item>
                </a-col>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="相关附件" name="annexAddress">
                        <FileUpload :isPdf="true" :count="50" :size="30"  :names="'上传相关附件(PDF文件)'" v-model:value="form.annexAddress" />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-col :span="24" style="text-align: center;">
                <a-button type="primary" html-type="submit" @click="onSubmit">
                    相关附件保存
                </a-button>
            </a-col>
        </a-form>

    </div>
    </a-card>
</template>
<script>
import store from '@/store';
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {projectAnnex} from "@/api/TechnologieprojekteApply";

export default {
    name: "相关附件",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            form: {
                    id: null,
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                    annexAddress: null,
            },
            rules: {
                    id: [],
                    projectId: [
                        dataCheck.required({}),
                    ],
                    classification: [
                        dataCheck.required({}),
                    ],
                    annexAddress: [
                    ],
            },

            options: [],

        }
    },

    computed: {
            submitUrl() {
                return projectAnnex.saveOrUpdate
            }
        },
    mounted() {
        if(this.$route.query.id){
            this.onEdit()
        }
    },
    methods: {
        onEdit() {
            this.getAction({
                url: projectAnnex.detailByProject,
                params: {
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                 }
            }).then(res => {
                if(res){
                    this.form = res
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
</style>
